import moment from "moment";
import { capitalizeFirstLetter } from "../";

export const getShortMonthNameFromNumber = (monthNumber: number) => {
  return capitalizeFirstLetter(
    moment()
      .month(monthNumber - 1)
      .format("MMM"),
  );
};
